import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" })
	]
});
const ForwardRef = forwardRef(SvgScan);
export default ForwardRef;
